import { render, staticRenderFns } from "./Moodle.vue?vue&type=template&id=b3f3483e"
import script from "./Moodle.vue?vue&type=script&lang=js"
export * from "./Moodle.vue?vue&type=script&lang=js"
import style0 from "./Moodle.vue?vue&type=style&index=0&id=b3f3483e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports